import React, { useEffect, useState } from 'react'
import "./CustomModel.css"
import { Button, Modal } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import CustomInput from '../CustomInput/CustomInput';
import axios from 'axios';
function CustomModel(props) {
  console.log("props", props);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [resson, setReson] = useState('');
  const [amount, setAmount] = useState(null)
  const userinfo = useSelector((state) => state);
console.log(props?.acceptStatus);
useEffect(() => {
  if(props?.defualtPrice){
    setAmount(props?.defualtPrice)
  }
}, [props?.defualtPrice])
  const handleReject = async () => {
    
    const endPoint = props?.acceptStatus == "student-fees" ? `https://nanosoft.space/taarteb/public/api/admin/${props?.acceptStatus}/${props?.id}` : props?.acceptStatus == "student-expenses" ? `https://nanosoft.space/taarteb/public/api/admin/${props?.acceptStatus}/${props?.id}` : `https://nanosoft.space/taarteb/public/api/admin/${props?.acceptStatus}/${props?.id}/reject`
    const data = props?.acceptStatus == "student-fees" ? {
      reason: resson,
      status: "rejected"
    } : props?.acceptStatus == "student-expenses" ? {
      rejected_reason: resson,
      status: "rejected"

    } :
      {
        reject_reason: resson
      }

    await axios
      .post(endPoint, data, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
        }
      })
      .then(async (res) => {
        const fetchedItems = res.data;
        props?.onHide();




      })
      .catch((error) => {





      });
  }
  const handleAccept = async () => {
    //  const endPoint=`https://nanosoft.space/taarteb/public/api/admin/${props?.acceptStatus}/${props?.id}/accept`
    const endPoint = props?.acceptStatus == "student-fees" ? `https://nanosoft.space/taarteb/public/api/admin/${props?.acceptStatus}/${props?.id}` : props?.acceptStatus == "student-expenses" ? `https://nanosoft.space/taarteb/public/api/admin/${props?.acceptStatus}/${props?.id}` : `https://nanosoft.space/taarteb/public/api/admin/${props?.acceptStatus}/accept`
    const data = props?.acceptStatus == "student-fees" ? {
      status: "accepted"
    } : props?.acceptStatus == "student-expenses" ? {
      status: "accepted",
      amount_paid: amount


    } :props?.acceptStatus=="purchases"?
{purchase_ids:props?.id}
    :
      {maintenance_ids:props?.id}
    await axios
      .post(endPoint, data, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {
        const fetchedItems = res.data;
        props?.onHide();




      })
      .catch((error) => {





      });
  }

  console.log(props?.acceptStatus == "student-expenses");
  
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className='border-0'>

        </Modal.Header>
        <Modal.Body>
          {props?.status === "reject" &&
            <>
              <p className='text-center fw-bold'>{currentLocal?.home?.areyousureyouwantreject}</p>

              <form>
                <CustomInput
                  placeholder={currentLocal.home.resonOfreject}
                  value={resson}
                  onChange={(e) => setReson(e.target.value)}

                />
              </form>
            </>

          }
          {props?.status == "accept" &&
            <>
              <p className='text-center fw-bold'>{currentLocal?.home?.areyousureyouwantaccept}</p>
              {props?.acceptStatus == "student-expenses" &&
                props.is_registration_fee !== 1 &&
                <>
                  <label>{currentLocal.home.amount_paid}</label>

                  <CustomInput
                    placeholder={currentLocal.home.amount_paid}
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </>
              }

            </>

          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props?.status === "accept" ? handleAccept : handleReject} variant="primary">{props?.status === "accept" ? currentLocal.home.accept : currentLocal.home.reject}</Button>
          <Button onClick={props.onHide} variant="danger">{currentLocal.home.close}</Button>
        </Modal.Footer>
      </Modal>

    </>
  )
}

export default CustomModel